<template>
  <div class="poster">

    <img :src="img" width="100%" />

    <div class="poster-title">长按保存图片</div>
    <Floating />
  </div>
</template>

<script>

  export default {
    components: {
    },
    name: 'share',
    data() {
      return {
        img: "",
      };
    },
    created() {
      this.getPoster()
    },
    methods: {
      getPoster() {
        this.$api.post('poster/store', { id: 1 }, r=>{
          this.img = r.data.url
        })
      }
    },
  }
</script>

<style scoped>
  .poster{
    background: #ffffff;
    width: 100%;
    height: 100%;
    position: fixed;
  }
  .poster-title{
    position: fixed;
    width: 100%;
    text-align: center;
    bottom: 10%;
    left: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/retails/share.vue